<template>
  <section class="pool-show mt-3">
    <div class="row">
      <div class="col"><h1>Pool Show</h1></div>
      <div class="col-auto">
        <router-link
          :to="`/app/swap?inMint=${pool?.mintA}&outMint=${pool?.mintB}`"
          class="btn btn-white"
          >SWAP</router-link
        >
      </div>
      <div class="col-auto">
        <router-link
          :to="`/app/liquidity?inMint=${pool?.mintA}&outMint=${pool?.mintB}`"
          class="btn btn-white"
          >LIQUIDITY</router-link
        >
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-md-6">
        <div class="card animate__animated animate__fadeIn h-100">
          <div class="card-header"></div>
          <div class="card-body">
            <h5 class="text-decoration-underline">Overview</h5>
            <table class="table table-borderless table-sm">
              <tbody v-if="pool">
                <tr>
                  <td>Pair</td>
                  <td>
                    <AccountAddress :address="pubkey"></AccountAddress>
                  </td>
                </tr>
                <tr>
                  <td>Owner</td>
                  <td>
                    <AccountAddress :address="poolOwner"></AccountAddress>
                  </td>
                </tr>
                <tr>
                  <td>Token A</td>
                  <td>
                    <AccountAddress :address="pool.mintA"></AccountAddress>
                  </td>
                </tr>
                <tr>
                  <td>Token B</td>
                  <td>
                    <AccountAddress :address="pool.mintB"></AccountAddress>
                  </td>
                </tr>
                <tr>
                  <td>LP</td>
                  <td>
                    <AccountAddress :address="pool.tokenPool"></AccountAddress>
                  </td>
                </tr>
                <!--							<tr>-->
                <!--								<td>Curve type</td>-->
                <!--								<td>{{ pool.curveType }}</td>-->
                <!--							</tr>-->
              </tbody>
            </table>

            <h5 class="text-decoration-underline mt-5">Fees</h5>
            <table class="table table-sm table-borderless text-start small">
              <tbody v-if="pool">
                <tr>
                  <td>Trade</td>
                  <td>
                    {{ pool.tradeFeeNumerator / pool.tradeFeeDenominator }}
                  </td>
                </tr>
                <tr>
                  <td>Owner Trade / Withdraw</td>
                  <td>
                    {{
                      pool.ownerTradeFeeNumerator /
                        pool.ownerTradeFeeDenominator || 0
                    }}
                    /
                    {{
                      pool.ownerWithdrawFeeNumerator /
                        pool.ownerWithdrawFeeDenominator || 0
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Host</td>
                  <td>
                    {{ pool.hostFeeNumerator / pool.hostFeeDenominator || 0 }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-6 mt-3 mt-md-0">
        <div class="card animate__animated animate__fadeIn">
          <div class="card-header row" v-if="pool?.mintA">
            <TokenImage class="col" :mint="pool.mintA"></TokenImage>
            <TokenPrice class="col text-end" :token="pool.mintA"></TokenPrice>
          </div>
          <div class="card-body">
            <table class="table table-borderless table-sm" v-if="tokenAccountA">
              <tbody>
                <tr>
                  <td>Account</td>
                  <td>
                    <AccountAddress
                      :address="pool.tokenAccountA"
                    ></AccountAddress>
                  </td>
                </tr>
                <tr>
                  <td>Amount</td>
                  <td>
                    {{
                      tokenAccountA?.data?.parsed.info.tokenAmount?.uiAmount?.toLocaleString()
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Type</td>
                  <td>{{ tokenAccountA?.data?.program }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="card animate__animated animate__fadeIn mt-3">
          <div class="card-header row" v-if="pool?.mintB">
            <TokenImage class="col" :mint="pool.mintB"></TokenImage>
            <TokenPrice class="col text-end" :token="pool.mintB"></TokenPrice>
          </div>
          <div class="card-body">
            <table class="table table-borderless table-sm" v-if="tokenAccountB">
              <tbody>
                <tr>
                  <td>Account</td>
                  <td>
                    <AccountAddress
                      :address="pool.tokenAccountB"
                    ></AccountAddress>
                  </td>
                </tr>
                <tr>
                  <td>Amount</td>
                  <td>
                    {{
                      tokenAccountB?.data?.parsed.info.tokenAmount?.uiAmount?.toLocaleString()
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Type</td>
                  <td>{{ tokenAccountB?.data?.program }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="card animate__animated animate__fadeIn mt-3">
          <div class="card-footer" v-if="tokenAccountA && tokenAccountB">
            <table class="table table-borderless mb-0">
              <tbody>
                <tr>
                  <td>Price:</td>
                  <td>
                    <span
                      >1 {{ mintA?.symbol?.toUpperCase().replace(/\0/g, "") }} ≈
                      {{ spotPrice.toFixed(mintB?.decimals) }}
                      {{
                        mintB?.symbol?.toUpperCase().replace(/\0/g, "")
                      }}</span
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div
      class="row mt-3"
      v-if="userLPAccount?.data.parsed.info.tokenAmount.uiAmount > 0"
    >
      <div class="col-12">
        <div class="card animate__animated animate__fadeIn">
          <div class="card-header">
            <div class="row">
              <div class="col"><h4>Your Liquidity</h4></div>
              <div class="col text-end">
                <router-link
                  class="text-decoration-none"
                  :to="`/app/liquidity?inMint=${pool?.mintA}&outMint=${pool?.mintB}`"
                  ><i class="fa fa-plus"></i> Add Liquidity</router-link
                >
              </div>
            </div>
          </div>
          <div class="card-body">
            <table class="table">
              <thead>
                <tr>
                  <th>Account</th>
                  <th>Owner</th>
                  <th class="text-end">LP Amount</th>
                  <th class="text-end">Token A ({{ mintA?.symbol }})</th>
                  <th class="text-end">Token B ({{ mintB?.symbol }})</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <AccountAddress :address="lpAta"></AccountAddress>
                  </td>
                  <td>
                    <AccountAddress
                      :address="userLPAccount?.data.parsed.info.owner"
                    ></AccountAddress>
                  </td>
                  <td class="text-end">
                    {{
                      userLPAccount?.data.parsed.info.tokenAmount.uiAmount.toLocaleString()
                    }}
                  </td>
                  <td class="text-end">
                    {{ ownLpTokenA.toFixed(mintA?.decimals) }}
                    {{ mintA?.symbol?.toUpperCase().replace(/\0/g, "") }}
                  </td>
                  <td class="text-end">
                    {{ ownLpTokenB.toFixed(mintB?.decimals) }}
                    {{ mintB?.symbol?.toUpperCase().replace(/\0/g, "") }}
                  </td>
                  <td class="text-end p-1">
                    <router-link
                      class="btn btn-solid-primary btn-sm me-2"
                      :to="`/app/liquidity?inMint=${pool?.mintA}&outMint=${pool?.mintB}`"
                      >Add</router-link
                    >
                    <button
                      @click="showAdjustLiquidity"
                      class="btn btn-solid-primary btn-sm"
                    >
                      Adjust
                    </button>
                    <button
                      @click="doRemoveLiquiditySlippage"
                      class="btn btn-outline-danger btn-sm ms-2"
                    >
                      Remove
                    </button>
                    <button
                      @click="doRemoveLiquidity"
                      class="btn btn-outline-danger btn-sm ms-2"
                    >
                      Remove All
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3" v-if="isNFTPool">
      <div class="col-12">
        <div class="card animate__animated animate__fadeIn">
          <div class="card-header">
            <div class="row">
              <div class="col"><h4>Pool Assets</h4></div>
              <div class="col text-end"></div>
            </div>
          </div>
          <div class="card-body">
            <PoolInfo :pool="nftPoolAddress"></PoolInfo>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3" v-if="showLP">
      <div class="col-12">
        <div class="card animate__animated animate__fadeIn">
          <div class="card-header">
            <div class="row">
              <div class="col"><h4>Liquidity Providers</h4></div>
              <div class="col text-end">
                <router-link
                  class="text-decoration-none"
                  :to="`/app/liquidity?inMint=${pool?.mintA}&outMint=${pool?.mintB}`"
                  ><i class="fa fa-plus"></i> Add Liquidity
                </router-link>
              </div>
            </div>
          </div>
          <div class="card-body">
            <table class="table">
              <thead>
                <tr>
                  <th>Account</th>
                  <th class="d-none d-lg-table-cell">Owner</th>
                  <!--								<th class="text-end">LP Amount</th>-->
                  <th class="text-end d-none d-md-table-cell">
                    Token A ({{
                      mintA?.symbol?.toUpperCase().replace(/\0/g, "")
                    }})
                  </th>
                  <th class="text-end d-none d-md-table-cell">
                    Token B ({{
                      mintB?.symbol?.toUpperCase().replace(/\0/g, "")
                    }})
                  </th>
                  <th class="text-end">USD Value</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="lp in filteredTopHolders" :key="lp.address">
                  <td>
                    <AccountAddress :address="lp.address"></AccountAddress>
                  </td>
                  <td class="d-none d-lg-table-cell">
                    <AccountAddress :address="lp.data?.owner"></AccountAddress>
                  </td>
                  <!--								<td class="text-end">{{ lp.uiAmount }}</td>-->
                  <td class="text-end d-none d-md-table-cell">
                    {{ lpTokenA(lp).toFixed(mintA?.decimals) }}
                  </td>
                  <td class="text-end d-none d-md-table-cell">
                    {{ lpTokenB(lp).toFixed(mintB?.decimals) }}
                  </td>
                  <td class="text-end">${{ lpTokenTotal(lp) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div
      class="transaction-status-modal-fixed container-fluid"
      v-show="showDialogue"
      @mousedown="close"
    >
      <div class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-4">
        <div id="dialogue" @mousedown="(e) => e.stopPropagation()">
          <div class="card animate__animated animate__fadeIn">
            <div class="card-header">
              <h4>Withdraw Liquidity</h4>
            </div>
            <div class="card-body">
              <div class="row mb-2">
                <div class="col"><h5 class="mb-0">LP Amount</h5></div>
                <div class="col-auto">
                  <code @click="setMax" class="mb-0 text-end">{{
                    userLPAccount?.data.parsed.info.tokenAmount.uiAmount
                  }}</code>
                </div>
              </div>
              <input
                class="form-control"
                placeholder="Enter amount"
                type="number"
                min="0"
                v-model.number="withdrawForm.lpInput"
                @keyup="onChangeA"
                @change="onChangeA"
              />
              <hr />
              <div class="row">
                <div class="col-6">
                  <div class="input-group">
                    <TokenImage
                      v-if="mintA"
                      :mint="mintA?.address"
                      :show-name="false"
                      :show-symbol="false"
                    ></TokenImage>
                    <input
                      readonly
                      class="form-control"
                      type="number"
                      min="0"
                      :value="
                        (
                          withdrawForm.amountA / Math.pow(10, mintA?.decimals)
                        ).toFixed(9)
                      "
                    />
                  </div>
                </div>
                <div class="col-6">
                  <div class="input-group">
                    <TokenImage
                      v-if="mintB"
                      :mint="mintB?.address"
                      :show-name="false"
                      :show-symbol="false"
                    ></TokenImage>
                    <input
                      readonly
                      class="form-control"
                      type="number"
                      min="0"
                      :value="
                        (
                          withdrawForm.amountB / Math.pow(10, mintB?.decimals)
                        ).toFixed(9)
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer text-end">
              <button class="btn btn-solid-primary" @click="doAdjustLiquidity">
                Withdraw
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { web3 } from "@project-serum/anchor";
import AccountAddress from "@/components/common/AccountAddress.vue";
import TokenImage from "@/components/common/TokenImage.vue";
import {
  getAssociatedTokenAddressSync,
  TOKEN_2022_PROGRAM_ID,
} from "@solana/spl-token";
import { parseCustomError } from "@/api/token_swap/errors";
import PoolInfo from "@/components/nft/PoolInfo.vue";
import SignatureLoader from "@/mixins/SignatureLoader";
import TokenPrice from "@/components/common/TokenPrice.vue";

export default {
  name: "PoolShow",
  components: { TokenPrice, PoolInfo, TokenImage, AccountAddress },
  mixins: [SignatureLoader],
  data() {
    return {
      fmt: new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      showDialogue: false,
      showLP: false,
      interval: null,
      pool: null,
      poolOwner: null,
      tokenAccountA: null,
      tokenAccountB: null,
      userLPAccount: null,
      tokenPool: null,
      mintA: null,
      mintB: null,
      topHolders: [],
      withdrawForm: {
        lpInput: 1000,
        amountA: 0,
        amountB: 0,
      },
    };
  },
  computed: {
    pubkey: function () {
      return this.$route.params.id;
    },
    spotPrice: function () {
      return (
        this.tokenAccountB?.data?.parsed.info.tokenAmount?.uiAmount /
        this.tokenAccountA?.data?.parsed.info.tokenAmount?.uiAmount
      );
    },
    lpAta: function () {
      if (!this.pool) return null;

      return getAssociatedTokenAddressSync(
        this.pool.tokenPool,
        new web3.PublicKey(this.$store.state.wallet.address),
				true,
        TOKEN_2022_PROGRAM_ID
      );
    },

    ownLpTokenA: function () {
      return this.lpTokenA(this.userLPAccount);
    },

    ownLpTokenB: function () {
      return this.lpTokenB(this.userLPAccount);
    },

    filteredTopHolders: function () {
      return this.topHolders.filter((h) => h.uiAmount > 0);
    },

    isNFTPool: function () {
      //TODO Check if mintA/B addresses are a pool
      return false;
    },
    nftPoolAddress: function () {
      //TODO Get pool address from mintA/B through nft_frac client
      return null;
    },
  },
  methods: {
    close: function () {
      this.showDialogue = false;
    },
    onChangeA: function () {
      const yourLpTokens = this.withdrawForm.lpInput * Math.pow(10, 2);

      // total LP tokens supply, you need to fetch this
      const totalLpSupply = this.tokenPool?.data.parsed.info.supply;

      // const totalTokenAInPool = this.tokenAccountA?.data?.parsed.info.tokenAmount?.uiAmount; // total token A in the pool
      // const totalTokenBInPool = this.tokenAccountB?.data?.parsed.info.tokenAmount?.uiAmount; // total token B in the pool

      const totalTokenAInPool =
        this.tokenAccountA?.data?.parsed.info.tokenAmount?.amount; // total token A in the pool
      const totalTokenBInPool =
        this.tokenAccountB?.data?.parsed.info.tokenAmount?.amount; // total token B in the pool

      // Calculate your share of the total liquidity
      const yourShareOfTotalLiquidity = yourLpTokens / totalLpSupply;
      console.log("LP Share: ", yourShareOfTotalLiquidity);

      // Calculate the amount of each token you can withdraw
      this.withdrawForm.amountA = totalTokenAInPool * yourShareOfTotalLiquidity;
      this.withdrawForm.amountB = totalTokenBInPool * yourShareOfTotalLiquidity;
    },

    getAccounts: function () {
      this.getLPProviders(this.pool.tokenPool);

      this.$store.state.solana.client
        .getMultipleParsedAccounts([
          this.pool.tokenAccountA,
          this.pool.tokenAccountB,
          this.lpAta,
          this.pool.tokenPool,
        ])
        .then((rs) => {
          this.tokenAccountA = rs.value[0];
          this.tokenAccountB = rs.value[1];
          this.userLPAccount = rs.value[2];
          this.tokenPool = rs.value[3];
        });

      this.mintA = this.$store.state.cache.tokenMap[this.pool.mintA];
      this.mintB = this.$store.state.cache.tokenMap[this.pool.mintB];
    },

    getLPProviders: async function (lpMint) {
      const r = await this.$store.state.solana.client
        .getTokenLargestAccounts(lpMint)
        .catch();
      if (!r) return;

      const holderPks = [];
      r.value.forEach((h) => holderPks.push(h.address));
      const rInfo =
        await this.$store.state.solana.client.getMultipleParsedAccounts(
          holderPks
        );
      for (let i = 0; i < r.value.length; i++) {
        r.value[i].data = rInfo.value[i]?.data.parsed.info;
      }
      this.topHolders = r.value;
    },

    setMax: function () {
      this.withdrawForm.lpInput =
        this.userLPAccount?.data.parsed.info.tokenAmount.uiAmount;
      this.onChangeA();
    },

    showAdjustLiquidity: function () {
      this.showDialogue = true;
      this.onChangeA();
    },

    doAdjustLiquidity: async function () {
      this.loading = true;

      // your LP tokens
      const yourLpTokens = this.withdrawForm.lpInput * Math.pow(10, 2);

      await this._doRemoveLiquidity(yourLpTokens).catch((e) => {
        console.error("Adjust Liquidity failed", e);
        this.$toastr.e(
          parseCustomError(e.message || e),
          "Remove Liquidity failed"
        );
        window.gtag("event", "remove_liquidity_fail", { error: e });
      });
      this.loading = false;
      setTimeout(() => {
        this.$store.dispatch("cache/refreshUserBalance");
        this.getAccounts(this.form);
      }, 3000);
    },

    doRemoveLiquidity: async function () {
      this.loading = true;

      // your LP tokens
      const yourLpTokens =
        this.userLPAccount?.data.parsed.info.tokenAmount.amount;

      await this._doRemoveLiquidity(yourLpTokens).catch((e) => {
        console.error("Remove Liquidity failed", e);
        this.$toastr.e(
          parseCustomError(e.message || e),
          "Remove Liquidity failed"
        );
        window.gtag("event", "remove_liquidity_fail", { error: e });
      });
      this.loading = false;
      setTimeout(() => {
        this.$store.dispatch("cache/refreshUserBalance");
        this.getAccounts(this.form);
      }, 3000);
    },

    //Force remove all liquidity
    _doRemoveLiquidity: async function (yourLpTokens) {
      const txn =
        await this.$store.state.solana.swapClient.createRemoveLiquidityTransaction(
          new web3.PublicKey(this.$store.state.wallet.address),
          new web3.PublicKey(this.pubkey),
          this.pool,
          yourLpTokens,
          0,
          0,
          this.$store.getters["settings/priorityFee"]
        );

      return await this.signAndSendTransaction(txn, "remove_liquidity", []);
    },

    doRemoveLiquiditySlippage: async function () {
      this.loading = true;

      // your LP tokens
      const yourLpTokens =
        this.userLPAccount?.data.parsed.info.tokenAmount.amount;

      await this._doRemoveLiquiditySlippage(yourLpTokens).catch((e) => {
        console.error("Remove Liquidity failed", e);
        this.$toastr.e(
          parseCustomError(e.message || e),
          "Remove Liquidity failed"
        );
        window.gtag("event", "remove_liquidity_fail", { error: e });
      });
      this.loading = false;
      setTimeout(() => {
        this.$store.dispatch("cache/refreshUserBalance");
        this.getAccounts(this.form);
      }, 3000);
    },

    _doRemoveLiquiditySlippage: async function (yourLpTokens) {
      // total LP tokens supply, you need to fetch this
      const totalLpSupply = this.tokenPool?.data.parsed.info.supply;

      const totalTokenAInPool =
        this.tokenAccountA?.data?.parsed.info.tokenAmount?.amount; // total token A in the pool
      const totalTokenBInPool =
        this.tokenAccountB?.data?.parsed.info.tokenAmount?.amount; // total token B in the pool

      // Calculate your share of the total liquidity
      const yourShareOfTotalLiquidity = yourLpTokens / totalLpSupply;

      // Calculate the amount of each token you can withdraw
      const poolTokensIn = yourLpTokens;
      const minTokenAOut = totalTokenAInPool * yourShareOfTotalLiquidity;
      const minTokenBOut = totalTokenBInPool * yourShareOfTotalLiquidity;

      const minTokenAOutSlippage =
        minTokenAOut -
        minTokenAOut * (this.$store.state.settings.slippage / 100);
      const minTokenBOutSlippage =
        minTokenBOut -
        minTokenBOut * (this.$store.state.settings.slippage / 100);

      const txn =
        await this.$store.state.solana.swapClient.createRemoveLiquidityTransaction(
          new web3.PublicKey(this.$store.state.wallet.address),
          new web3.PublicKey(this.pubkey),
          this.pool,
          poolTokensIn,
          minTokenAOutSlippage,
          minTokenBOutSlippage,
          this.$store.getters["settings/priorityFee"]
        );

      return await this.signAndSendTransaction(txn, "remove_liquidity", []);
    },

    getPool: function () {
      this.$store.state.solana.swapClient
        .getPool(new web3.PublicKey(this.$route.params.id))
        .then((r) => {
          this.pool = r.account;
          this.poolOwner = r.owner;
          this.getAccounts();

          console.log("Pool", r.account.hostFeeDenominator.toString(10));
        });
    },

    lpTokenA: function (account) {
      if (!account) return 0;

      const yourLpTokens =
        account.data?.parsed?.info.tokenAmount.amount ||
        account.data?.tokenAmount?.amount;
      const totalLpSupply = this.tokenPool?.data.parsed.info.supply;
      const totalTokenAInPool =
        this.tokenAccountA?.data?.parsed.info.tokenAmount?.amount; // total token B in the pool

      const yourShareOfTotalLiquidity = yourLpTokens / totalLpSupply;

      return (
        (totalTokenAInPool * yourShareOfTotalLiquidity) /
        Math.pow(
          10,
          this.tokenAccountA?.data?.parsed.info.tokenAmount?.decimals || 9
        )
      );
    },

    lpTokenB: function (account) {
      if (!account) return 0;

      const yourLpTokens =
        account.data?.parsed?.info.tokenAmount.amount ||
        account.data?.tokenAmount?.amount;
      const totalLpSupply = this.tokenPool?.data.parsed.info.supply;
      const totalTokenBInPool =
        this.tokenAccountB?.data?.parsed.info.tokenAmount?.amount; // total token B in the pool

      const yourShareOfTotalLiquidity = yourLpTokens / totalLpSupply;

      return (
        (totalTokenBInPool * yourShareOfTotalLiquidity) /
        Math.pow(
          10,
          this.tokenAccountB?.data?.parsed.info.tokenAmount?.decimals || 9
        )
      );
    },

    lpTokenTotal: function (account) {
      if (!account) return;

      const tokA = this.lpTokenA(account);
      const tokB = this.lpTokenB(account);

      return this.fmt.format(
        tokA * this.$store.getters.tokenPrice(this.pool?.mintA) +
          tokB * this.$store.getters.tokenPrice(this.pool?.mintB)
      );
    },
  },
  beforeMount() {
    this.showLP = !!this.$route.query.lp;

    this.getPool();
    this.interval = setInterval(() => {
      this.getPool();
    }, 60000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<style scoped>
tr :last-child {
  text-align: right;
}
</style>
